import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordDeviceMatchV1Body } from './record-device-match-v1-request';
import type { IRecordDeviceMatchV1Response } from './record-device-match-v1-response';
import { recordDeviceMatchV1ResponseSchema } from './record-device-match-v1-response';

export async function recordDeviceMatchV1Api(
  body: IRecordDeviceMatchV1Body,
): Promise<IValidatedResponse<IRecordDeviceMatchV1Response>> {
  return postRequest<IRecordDeviceMatchV1Response>({
    path: '/account/device-match/v1',
    body,
    schema: recordDeviceMatchV1ResponseSchema,
  });
}
